import React from "react";

const SUBSET = new Set("₀₁₂₃₄₅₆₇₈₉".split(""));

// Preserves Unicode subscript characters but renders the ₀–₉ glyphs with a
// subscript-capable font so they display correctly inside serif/display styles
// (Cormorant Garamond lacks reliable subscript glyphs).
export function Subs({ children, className = "" }) {
  const s = String(children ?? "");
  return (
    <span className={className}>
      {[...s].map((ch, i) =>
        SUBSET.has(ch) ? <span key={i} className="me-sub">{ch}</span> : ch
      )}
    </span>
  );
}
